var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModuloInvitados(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 99.3 99.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #b2b2b2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 22.76,
    cy: 10.34,
    r: 10.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.03,24.82H14.48c-7.99,0-14.48,6.5-14.48,14.48v35.17h8.27v24.82h12.41v-24.82h4.14v24.82h12.41v-24.82h8.27v-35.17c0-7.99-6.5-14.48-14.48-14.48Zm2.07,37.24H12.41v-22.76c0-1.14.93-2.07,2.07-2.07h16.55c1.14,0,2.07.93,2.07,2.07v22.76Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 76.54,
    cy: 10.34,
    r: 10.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m84.82,24.82h-16.55c-7.99,0-14.48,6.5-14.48,14.48v35.17h8.27v24.82h12.41v-24.82h4.14v24.82h12.41v-24.82h8.27v-35.17c0-7.99-6.5-14.48-14.48-14.48Zm2.07,37.24h-20.69v-22.76c0-1.14.93-2.07,2.07-2.07h16.55c1.14,0,2.07.93,2.07,2.07v22.76Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuloInvitados);
export default __webpack_public_path__ + "static/media/moduloInvitados.e4e8f1a156f6946b9ef6eb4740e5d0a6.svg";
export { ForwardRef as ReactComponent };